import * as forge from 'node-forge';
export function setupCryptoPolyfill() {

  if (!window.isSecureContext) {
      console.warn(
        "Your environment is not secure (not HTTPS). Mocking Crypto.subtle for development purposes."
      );
    
      if (!globalThis.crypto) {
        globalThis.crypto = {};
      }
    
      globalThis.crypto.subtle = {
        digest: async (algorithm, data) => {
          if (algorithm !== "SHA-256") {
            throw new Error("Only SHA-256 is supported.");
          }
          const md = forge.md.sha256.create();
          md.update(forge.util.createBuffer(new Uint8Array(data)).getBytes());
          return new Uint8Array(md.digest().bytes().split("").map(c => c.charCodeAt(0))).buffer;
        },
    
        generateKey: async (algorithm, extractable, keyUsages) => {
          if (algorithm.name !== "ECDSA" || algorithm.namedCurve !== "P-256") {
              throw new Error("Only ECDSA with P-256 is supported.");
          }
          const keys = forge.pki.ec.generateKeyPair({ namedCurve: "P-256" });
          return {
              privateKey: keys.privateKey,
              publicKey: keys.publicKey,
          };
        },
    
        exportKey: async(format, key) =>  {
          if (format === "jwk") {
              if (key.type === "private") {
                  return forge.pki.privateKeyToJwk(key);
              } else if (key.type === "public") {
                  return forge.pki.publicKeyToJwk(key);
              }
          }
          throw new Error("Unsupported export key format or type.");
        },
    
        sign: async (algorithm, privateKey, data)  => {
            if (algorithm.name !== "ECDSA" || algorithm.hash.name !== "SHA-256") {
                throw new Error("Only ECDSA with SHA-256 is supported.");
            }
            const md = forge.md.sha256.create();
            md.update(forge.util.createBuffer(new Uint8Array(data)).getBytes());
            const signature = privateKey.sign(md);
            return new Uint8Array(forge.util.createBuffer(signature).bytes().split("").map(c => c.charCodeAt(0)));
        },
    
        verify: async (algorithm, publicKey, signature, data) => {
            if (algorithm.name !== "ECDSA" || algorithm.hash.name !== "SHA-256") {
                throw new Error("Only ECDSA with SHA-256 is supported.");
            }
            const md = forge.md.sha256.create();
            md.update(forge.util.createBuffer(new Uint8Array(data)).getBytes());
            return publicKey.verify(md.digest().bytes(), forge.util.createBuffer(signature).getBytes());
        },
      };
    }
  }